import {resize} from "./components/header/resize.js";




((document, window, history) => {
	const pushState = history.pushState;


	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
	

        resize();
    });
}

)(document, window, history);